<i18n>
{
  "ru":{
    "modal_title": "Выберите язык",
    "print_check": "Распечатать",
    "language_placeholder": "Язык"
  },
  "en":{
    "modal_title": "Select language",
    "print_check": "Print",
    "language_placeholder": "Language"
  }
}
</i18n>
<template>
  <el-dialog
    :close-on-click-modal="false"
    custom-class="webpay check language"
    class="check-language-modal"
    :visible.sync="visibleInner"
    width="240px"
    align-center
    append-to-body
  >
    <span class="aligner" slot="title">
      <h4>{{ $t("modal_title") }}</h4>
    </span>
    <section>
      <el-row class="aligner">
        <el-select v-model="selected" class="m-2" :placeholder="$t('language_placeholder')" size="large">
          <el-option
              v-for="(language, url) in pdf_check_urls"
              :key="url"
              :label="language"
              :value="url"
          />
        </el-select>
      </el-row>
      <el-row class="aligner">
        <el-button round plain type="primary" @click="printCheck">{{
            $t("print_check")
          }}</el-button>
      </el-row>
    </section>
  </el-dialog>
</template>

<script>

export default {
  name: 'check-language-modal',
  props: ['visible', 'pdf_check_urls'],
  data () {
    return {
      selected: Object.keys(this.pdf_check_urls)[0]
    }
  },
  methods: {
    printCheck () {
      window.open(this.selected, '_blank')
      this.visibleInner = false
    }
  },
  computed: {
    visibleInner: {
      get () {
        return this.visible
      },
      set (val) {
        if (!val) {
          this.$emit('update:visible', false)
        }
      }
    }
  }
}
</script>

<style>
.el-dialog.check.language h4 {
  font-size: 16px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.31;
  letter-spacing: normal;
  text-align: left;
  color: #c1c1c1;
  padding: 0;
}
</style>
